import { FirestoreDataConverter } from "firebase/firestore";
import { map } from "lodash";
import moment from "moment";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";
import Checkpoint from "../models/checkpoint";
import CheckpointAtivo from "../models/checkpointAtivo";

export default class CheckpointDb extends BaseDb<
  Checkpoint,
  { usuarioId: string; checkpointId: string }
> {
  _path: string = "usuarios/usuarioId/checkpoints/checkpointId";
  getConverter(): FirestoreDataConverter<Checkpoint> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Checkpoint({
          data: moment(snapshot.get("data").toDate()),
          posicoes: map(
            snapshot.get("posicoes"),
            CheckpointAtivo.fromFirestore
          ),
        }),
      toFirestore: toFirestore,
    };
  }
}
